import { render } from "./specificGift_add.vue?vue&type=template&id=5e725e47"
import script from "./specificGift_add.vue?vue&type=script&lang=js"
export * from "./specificGift_add.vue?vue&type=script&lang=js"
script.render = render

export default script